module.exports = "<button type=\"button\" class=\"{{styleClass}}\" (click)=\"openDaumApi()\">{{btnText}}</button>"